import React from 'react';
import { useLocation } from 'react-router-dom';

import Tabs, { Tab } from '../../../../library/tabs/tabs';
import Tooltip from '../../../../library/tooltip/tooltip';

import { useMessage } from '../../../../shared/hooks/hooks';

import { getTabURLParams } from '../../../../shared/utils/url-params/url-params';

import { CheckFitResult } from '../../../../shared/constants/fit';
import { WIPER_SETS_TAB_MSG } from '../../../../shared/constants/messages';
import { SetSearchTypes } from '../../../../shared/constants/set-products';

import styles from './set-product-tabs.scss';

interface SetProductTabsProps {
  doesFitEnum: CheckFitResult;
  productSetSearchType: string;
}

function SetProductTabs(props: SetProductTabsProps) {
  const { doesFitEnum, productSetSearchType } = props;
  const { pathname, search } = useLocation();
  const messages = useMessage([WIPER_SETS_TAB_MSG]);

  if (doesFitEnum !== CheckFitResult.FIT || !productSetSearchType) {
    return null;
  }

  const tooltipContent =
    messages?.WIPER_SETS_TAB_MSG ||
    'A wiper blade set includes driver and passenger side blades. We recommend replacing both for the best performance.';

  const basePath = pathname.replace(
    `/${productSetSearchType.toLowerCase()}`,
    ''
  );
  const urlParams = getTabURLParams(search);

  return (
    <div className={styles['container']}>
      <Tabs isSecondary>
        <Tab
          href={`${basePath}/set${urlParams}`}
          isSelected={productSetSearchType === SetSearchTypes.SET}
        >
          <strong>Wiper Sets</strong>
          <Tooltip
            className={styles['sets-tooltip']}
            content={tooltipContent}
          />
        </Tab>
        <Tab
          href={`${basePath}/driver${urlParams}`}
          isSelected={productSetSearchType === SetSearchTypes.DRIVER}
        >
          <strong>Driver Side</strong>
        </Tab>
        <Tab
          href={`${basePath}/passenger${urlParams}`}
          isSelected={productSetSearchType === SetSearchTypes.PASSENGER}
        >
          <strong>Passenger Side</strong>
        </Tab>
      </Tabs>
    </div>
  );
}

export default SetProductTabs;
